import { render, staticRenderFns } from "./Accueil.vue?vue&type=template&id=bd11ebdc&scoped=true&"
import script from "./Accueil.vue?vue&type=script&lang=js&"
export * from "./Accueil.vue?vue&type=script&lang=js&"
import style0 from "./Accueil.vue?vue&type=style&index=0&id=bd11ebdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd11ebdc",
  null
  
)

export default component.exports